<template>
  <div v-click-outside="closeDropdown" @click.prevent.stop="onClickPrevent">
    <v-select type="text" :item-text="attributeSearch1" persistent-hint ref="select" v-bind="selectAttributes"
  :id="uid" :uid="uid" :ref="uid" v-model="localValue" :placeholder="placeholder" menu-props="auto"
 :searchable="searchable" :options="localOptions" label="label" :loading="isLoading"
  :disabled="disabled" :valueProp="valueProp" :getOptionLabel="option => option.label" :clearable="clearable" @open="$emit('open', $event)"
  :append-to-body="autoDropdownPlacement" :reduce="reduce" @search="$emit('search', $event)" :filter="filter" @option:selected="$emit('option:selected', $event)"
    :calculate-position="calcPositionWithPopper" :multiple="multiple" v-bind:class="{ 'invalid-state': state === false }">
      <template #option="option">
        <slot name="option" :option="option"></slot>
      </template>
      <template #no-options>
        {{ noOptionsTitle || $t('signupOH.no-options') }}
      </template>
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6">
            <path id="Path_4_Copy" data-name="Path 4 Copy" d="M0,0,6,6,0,12Z" transform="translate(12) rotate(90)" fill="#8a8a8a"/>
          </svg>
        </span>
      </template>
    </v-select>
    <b-form-invalid-feedback :state="state">
      {{ errorMsg }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import '@/plugins/vue-select'
import { SlideYUpTransition } from 'vue2-transitions'
import { get } from 'lodash'
import { createPopper } from '@popperjs/core'
import { BFormInvalidFeedback } from 'bootstrap-vue'

export default {
  name: 'base-select',
  components: {
    SlideYUpTransition,
    BFormInvalidFeedback
  },
  props: {
    value: [String, Object, Boolean, Number],
    placeholder: {
      type: String,
      required: false,
      default () {
        return this.$t('base-select.select-option')
      }
    },
    options: Array,
    filterable: {
      type: Boolean,
      required: false,
      default: false
    },
    valueSearch1: {
      type: String,
      required: false
    },
    attributeSearch1: {
      type: String,
      required: false
    },
    searchable: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: 'label'
    },
    loading: {
      type: Boolean,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
		disabledText: {
			type: String,
			required: false,
			default: null
		},
    valueProp: {
      type: String,
      required: false,
      default: 'value'
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    },
    autoDropdownPlacement: {
      type: Boolean,
      required: false,
      default: false
    },
    clean: {
      type: Boolean,
      required: false,
      default: false
    },
    dataAttributes: {
      type: Array,
      required: false,
      default: null
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    errorMsg: {
      type: String,
      required: false,
      default () {
        return this.$t('base-select.errorMsg')
      }
    },
    insideDiv: {
      type: Boolean,
      required: false,
      default: false
    },
    avoidDefaultSort: Boolean,
    reduce: Function,
    filter: Function,
    noOptionsTitle: String,
    selectAttributes: {
      type: Object,
      required: false,
      default: null
    }
    // dropdownShouldOpen: {
    //   type: Function,
    //   required: false
    // }
  },
  data () {
    return {
      uid: null,
      placement: 'top',
      localOptions: []
    }
  },
  methods: {
    onChangeRun () {
      this.uid = this._uid.toString()
    // Add CSS rule to hide .vs-search div inside selected option
      /* const style = document.createElement('style')
      document.head.appendChild(style)
      const sheet = style.sheet
      var styles = `#vs${this.uid}__combobox input.vs__search { position: absolute; !important }`
      sheet.insertRule(styles, 0) */
    },
    mapSelectedOption (option) {
      if (option === null) { return null }
      let mappedOpt = {}
      mappedOpt.label = get(this.options.find(element => element.value === option.toString() || element.value === option), this.label)
      mappedOpt.value = get(this.options.find(element => element.value === option.toString() || element.value === option), this.valueProp)
      return mappedOpt
    },
    mapOption (option) {
      if (option === null) { return null }
      let mappedOpt = {}
      mappedOpt.label = get(option, this.label)
      mappedOpt.value = get(option, this.valueProp)
      return mappedOpt
    },
    calcPositionWithPopper (dropdownList, component, { width }) {
      dropdownList.style.width = width
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1]
            }
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn ({ state }) {
              component.$el.classList.toggle(
                'drop-up',
                state.placement === 'top'
              )
            }
          }
        ]
      })
      return () => popper.destroy()
    },
    createDataAttributes () {
      const input = document.querySelector(`#vs${this.uid}__combobox input`)
      if (this.dataAttributes) {
        this.dataAttributes.forEach((item) => {
          input.dataset[item.key] = item.value
        })
      }
    },
		closeDropdown () {
			this.$refs[this.uid].open = false
		},
		onClickPrevent (e) {
			if (this.disabledText) {
				this.$store.dispatch('showInfoAlert', { text: this.disabledText })
				this.$refs[this.uid].open = false
			}
		}
  },
  computed: {
    isLoading () {
      return this.loading !== null ? this.loading : (!this.options || this.options.length === 0)
    },
    hasOptionSlot () {
      return !!this.$slots.option
    },
    localValue: {
      get () {
        if (!this.options) return null
        const option = this.options.find(option => option[this.valueProp] === this.value)
        if (!option) {
          if (this.options.length > 0 && this.value !== null) {
            this.$emit('input', null)
            this.$emit('change', null)
          }
          return null
        }
        this.onChangeRun()
        return this.mapOption(option)
      },
      set (value) {
        this.$emit('input', value ? value.value : value)
        this.$emit('change', value ? value.value : value)
      }
    }
  },
  created () {
    this.uid = this._uid.toString()

    // Add CSS rule to hide .vs-search div inside selected option
    if (this.insideDiv) {
      const style = document.createElement('style')
      document.head.appendChild(style)
      const sheet = style.sheet
      var styles = `#vs${this.uid}__combobox input.vs__search { position: absolute; !important }`
      sheet.insertRule(styles, 0)
    }
    /* this.localValue = this.mapOption(this.value)
    this.localValue = this.mapSelectedOption(this.value) */
    /* this.$watch('value', (value, old) => {
      if (!old || (value && old.value !== value.value)) {
        this.localValue = this.mapOption(value)
      }
    }) */
    this.localOptions = this.options.map((item) => {
      return this.mapOption(item)
    })
    this.$watch('options', value => {
			if (!value) return []
      const valueMapped = value.map((item) => {
        return this.mapOption(item)
      })
      this.localOptions = !value ? [] : this.avoidDefaultSort ? valueMapped : valueMapped.sort(function (a, b) {
          if (a.label < b.label) { return -1 }
          if (a.label > b.label) { return 1 }
          return 0
      })
      // if (!this.localOptions.some(item => item.value === (this.localValue ? this.localValue.value : this.localValue))) this.localValue = null
    })
  },
  mounted () {
    this.createDataAttributes()
    // this.localValue = this.clearable === true ? null : this.localValue
  }
}
</script>

<style lang="scss">
/* .v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
} */
.v-select{
  margin-bottom: 0rem !important;
	&:not(.vs--multiple) .vs__selected {
		left: 0;
		right: 0;
		margin-left: auto !important;
		margin-right: auto !important;
		width: fit-content;
	}
}
input {
  .v__search {
		width: 0;
	}
}


.vs__selected-options {
  padding: 0 1rem;
}

.vs__dropdown-menu {
  display: grid !important;
  text-align: left;
}

.drop-up .vs__dropdown-toggle{
  border-radius: 0px 0px $border-radius $border-radius;
  border-top-style: none;
  border-bottom-style: solid;
  border-bottom-color: initial;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}

[data-popper-placement="top"] {
  border-radius: $border-radius $border-radius 0px 0px;
  border-top-style: solid;
  border-bottom-style: none;
  border-bottom-color: initial;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}

.invalid-state {
  .vs__dropdown-toggle {
    border-color: $red;
  }
}

.vs--searchable:not(.vs--open), .vs--unsearchable:not(.vs--open) {
	.vs__search:not([placeholder]) {
		display: none;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/base/forms/BaseSelect.vue